import { render } from "./LeaguesView.vue?vue&type=template&id=fa0781e0&scoped=true"
import script from "./LeaguesView.vue?vue&type=script&lang=js"
export * from "./LeaguesView.vue?vue&type=script&lang=js"

import "./LeaguesView.vue?vue&type=style&index=0&id=fa0781e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0781e0"]])

export default __exports__